import * as angular from 'angular';

"use strict";
angular.module('FieldModule', ['monospaced.qrcode']);

export default 'FieldModule';
